<template>
    <div class="animated fadeIn" id="faturamento-competencia">
        <div class="card card-default">
            <div class="card-header">
                <div class="card-header"><i class="fa fa-money"></i> Faturamento AMS</div>
            </div>
            <div class="card-body">
                <div class="input-group mb-3 align-items-center" style="gap: 10px;">
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Competência
                    </span>
                    <date-picker input-class="form-control datepicker-custom-height" v-model="competencia" lang="pt-br"
                        format="MM/YYYY" type="month" @change="updateCompetencia"></date-picker>
                    <button class="btn btn-primary" style="height: 40px;" @click="filtrar"
                        :disabled="isLoading || !competencia">
                        <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                        <span v-else><i class="icon-magnifier"></i> Filtrar</span>
                    </button>
                </div>
                <!-- Tabela de resultados -->
                <div v-if="faturamento.length" class="table-responsive mt-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="font-weight-bold">
                            Total de Horas: <span >{{ totalRegistros }}</span>
                        </span>
                        <button class="btn btn-primary" style="height: 40px; min-width: 90px;" @click="copyFaturamento">
                            <i class="fa fa-copy"></i> Copiar
                        </button>
                    </div>
                    <table id="table-faturamento-ams" class="table table-bordered table-striped table-sm">
                        <thead>
                            <tr>
                                <th v-for="col in tableColumns" :key="col.key">{{ col.label }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in faturamento" :key="idx">
                                <td v-for="col in tableColumns" :key="col.key">{{ row[col.key] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="mt-4" v-if="tabelaCarregada && faturamento.length === 0">
                    <span>Nenhum registro encontrado.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Uteis from "@/mixins/utils.js";
import DatePicker from "vue2-datepicker";
export default {
    name: 'FaturamentoAmsIndex',
    mixins: [Uteis],
    components: {
        DatePicker,
    },
    data() {
        return {
            competencia: null,
            periodoInicio: null,
            periodoFinal: null,
            isLoading: false,
            faturamento: [],
            tabelaCarregada: false,
        }
    },
    computed: {
        tableColumns() {
            // Defina os nomes corretos das colunas aqui
            return [
                { key: "Demanda", label: "Demanda" },
                { key: "Data", label: "Data" },
                { key: "Inicio", label: "Início" },
                { key: "Fim", label: "Fim" },
                { key: "Quantidade Horas", label: "Qtd. Horas" },
                { key: "Descricao", label: "Descrição" },
                { key: "Usuario", label: "Usuário" }
            ];
        },
        totalRegistros() {
            // Soma a coluna "Quantidade Horas" de todos os registros, tratando string com vírgula e valores inválidos, e arredonda para 2 casas decimais
            const total = this.faturamento.reduce((total, row) => {
                let val = row["Quantidade Horas"];
                if (typeof val === "string") {
                    val = val.replace(',', '.').replace(/[^0-9.]/g, '');
                }
                val = parseFloat(val);
                return total + (isNaN(val) ? 0 : val);
            }, 0);
            return total.toFixed(2);
        }
    },
    methods: {
        updateCompetencia(date) {
            if (date) {
                const competenciaDate = new Date(date);

                const inicio = new Date(competenciaDate);
                inicio.setMonth(inicio.getMonth() - 1);
                inicio.setDate(26);
                this.periodoInicio = inicio;

                const fim = new Date(competenciaDate);
                fim.setDate(25);
                this.periodoFinal = fim;
            } else {
                this.periodoInicio = null;
                this.periodoFinal = null;
            }
        },
        async filtrar() {
            const formatDate = (date) => {
                if (!date) return null;
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };
            const dto = {
                competencia: formatDate(this.competencia),
            };
            try {
                this.isLoading = true;
                this.tabelaCarregada = false;
                const response = await this.$http.get(
                    "/faturamento/faturamento-ams",
                    { params: dto }
                );
                this.faturamento = Array.isArray(response.data) ? response.data : [];
                this.tabelaCarregada = true;
            } catch (e) {
                this.faturamento = [];
                this.tabelaCarregada = true;
                this.$toasted.error('Erro ao buscar faturamento.');
            } finally {
                this.isLoading = false;
            }
        },
        copyFaturamento() {
            // Copia a tabela para a área de transferência, exceto a coluna Usuário
            const columns = this.tableColumns.filter(col => col.key !== "Usuario");
            let tsv = columns.map(col => col.label).join('\t') + '\n';
            this.faturamento.forEach(row => {
                tsv += columns.map(col => row[col.key]).join('\t') + '\n';
            });
            // Copiar para área de transferência
            const textarea = document.createElement('textarea');
            textarea.value = tsv;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        },
    },
    mounted() {
        // ...existing code...
    }
}
</script>

<style>
.input-group-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    font-size: 14px;
    height: 40px;
}

/* DatePicker customizado para altura igual ao span */
.datepicker-custom {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
    font-size: 14px;
}

/* Altura aumentada para o date-picker */
.datepicker-custom-height {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 14px;
}

/* Customização do dropdown */
.custom-dropdown .dropdown-toggle {
    display: inline-block;
    /* garante alinhamento */
    vertical-align: middle;
    background-color: transparent !important;
    border: 1px solid #dde2e7 !important;
    color: #6c757d !important;
    border-radius: 4px;
    min-width: 280px;
    width: 280px;
    height: 40px;
    line-height: 1.5;
}


.custom-dropdown .dropdown-toggle:hover,
.custom-dropdown .dropdown-toggle:focus,
.custom-dropdown .dropdown-toggle:active {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
    box-shadow: none !important;
}

.custom-dropdown.show .dropdown-toggle {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
}

.custom-dropdown .dropdown-menu {
    border: 1px solid #6c757d;
    border-radius: 4px;
    min-width: 280px;
    width: 280px;
}

.custom-dropdown .dropdown-item {
    min-width: 250px;
    width: 250px;
}
</style>